import type { RouteComponent, RouteLocationRaw } from "vue-router";

/** 路由懒加载组件（`() => import("xxx.vue")`）的返回类型 */
type LazyViewComponent = () => Promise<RouteComponent>;

export interface WebStyleState {
  routeTitle: string;
  title: string;
}

export type Tab = {
  name: string;
  path?: string;
  title: string;
  icon?: string;
  showSidebar: boolean;
  disablePath?: boolean;
  disableGenerateTab?: boolean;
  redirect?: string;
  needLogin?: boolean;
  component?: LazyViewComponent;
  auths?: string[]; // 所需要的权限，需要所配置全部的权限才会显示
};

export type View = {
  name: string;
  tab: string;
  sidebar: string;
  path: string;
  title: string;
  icon: string;
  disableTabPath?: boolean;
  disableSidebar?: boolean;
  needLogin?: boolean;
  /**
   * 同一界面挂在多条路由上时的共用页面标识（如 AI 教练主界面的 /ai/conversation 与 /ai/conversation/:id）。
   * 声明后 App.vue 不再按 fullPath 判定「换页」：同页切换地址既不重建组件、也不闪顶部加载条，
   * 选中态因此可以放心写回地址栏。不声明则维持原行为（参数变化即重建）。
   */
  viewKey?: string;
  props?: Record<string, unknown>;
  component: LazyViewComponent;
  auths: string[]; // 所需要的权限，需要所配置全部的权限才会显示
};

export type ViewGroup = {
  title: string;
  children: View[];
};

export type ViewList = (View | ViewGroup)[];

export type MenuGroup = {
  title: string;
  children: Menu[];
};

export type Menu = {
  name: string;
  title: string;
  icon?: string;
  iconClass?: string;
  to?: RouteLocationRaw;
  children?: Menu[];
};

export type MenuList = (Menu | MenuGroup)[];

export function IsViewGroup(item: View | ViewGroup): item is ViewGroup {
  return (item as ViewGroup).children !== undefined;
}

export function IsMenuGroup(item: Menu | MenuGroup): item is MenuGroup {
  return (item as MenuGroup).children !== undefined;
}
